import { actionTypes } from "./actionTypes";

// Dark Mode
export const toggleDarkMode = () => ({
  type: actionTypes.TOGGLE_DARK_MODE,
});
